export default {
    'editor': {
        'heading_1': 'Heading 1',
        'heading_2': 'Heading 2',
        'heading_3': 'Heading 3',
        'paragraph': 'Paragraph',
        'bold': 'Bold',
        'italic': 'Italic',
        'underline': 'Underline',
        'ordered_list': 'Ordered list',
        'bullet_list': 'Bullet list',
        'align_left': 'Align left',
        'align_center': 'Align center',
        'align_right': 'Align right',
        'align_justify': 'Justify',
        'link': 'Link',
        'color': 'Text color',
        'image': 'Image',
        'divider': 'Divider'
    },
    'colors': {
        'red': 'Red',
        'orange': 'Orange',
        'yellow': 'Yellow',
        'green': 'Green',
        'blue': 'Blue',
        'purple': 'Purple',
        'pink': 'Pink',
        'gray': 'Gray'
    },
    'general': {
        'administration': 'Administration',
        'dashboard': 'Dashboard',
        'email': 'Email',
        'phone': 'Phone',
        'username': 'Username',
        'name': 'Name',
        'password': 'Password',
        'value': 'Value',
        'actions': 'Actions',
        'login': 'Login',
        'logout': 'Logout',
        'no_results': 'No results',
        'success': 'Success',
        'warning': 'Warning',
        'remember_me': 'Remember me',
        'error': 'Error',
        'edit': 'Edit',
        'details': 'Details',
        'add': 'Add',
        'delete': 'Delete',
        'yes': 'Yes',
        'no': 'No',
        'cancel': 'Cancel',
        'back': 'Back',
        'image': 'Image',
        'filters': 'Filters',
        'remove_filters': 'Remove filters',
        'default': 'Default',
        'save': 'Save',
        'preview': 'Preview',
        'icon': 'Icon',
        'change': 'Change',
        'unlimited': 'Unlimited',
        'active': 'Active',
        'all': 'All',
        'from': 'From',
        'to': 'To',
        'date': 'Date',
        'custom': 'Custom',
        'country': 'Country',
        'total': 'Total',
        'basic_data': 'Basic data',
        'show_more': 'Show more',
        'export_data': 'Export data',
        'approve': 'Approve',
        'reject': 'Reject',
        'generate': 'Generate',
        'check': 'Check',
        'file_type': 'File type',
        'size': 'Size',
        'text': 'Text',
        'title': 'Title',
        'address': 'Address',
        'zip': 'Postal code',
        'city': 'City',
        'created': 'Created',
        'drag_and_drop_files_to_upload': 'Drag and drop files to upload',
        'file_missing': 'File is missing',
        'upload_failed': 'Upload failed',
        'retry_upload': 'Try again',
        'delete_all': 'Delete all',
        'left': 'Left',
        'right': 'Right',
        'top': 'Top',
        'bottom': 'Bottom',
        'settings': 'Settings',
        'instructions': 'Instructions',
        'instructions_admin_portal': 'Administration portal instructions',
        'instructions_website_images': 'Website images instructions',
        'open': 'Open',
        'download': 'Download',
        'guarantee_specification': 'Guarantee specification'
    },
    'errors': {
        'generic_error': 'There was an error',
        'login': 'There was an error logging in',
        'logout': 'There was an error logging out',
        'incorrect_password': 'The old password is incorrect',
        'invalid_data': 'Invalid data received',
        'not_found': 'Data not found',
        'user_exist': 'User with this email already exists',
        'load_data': 'There was an error loading data',
        'on_upload_file': 'There was an error uploading files',
        'on_export_file': 'There was an error exporting the file',
        'on_import_file': 'There was an error importing the file',
        'on_add': 'There was an error adding',
        'on_edit': 'There was an error editing',
        'on_delete': 'There was an error deleting',
        'on_sort': 'There was an error sorting',
        'unauthorized': 'Unauthorized',
        'user_does_not_exist': 'User does not exists',
        'failed_to_insert': 'Failed to insert',
        'file_to_big': 'File is to big',
        'file_type_not_allowed': 'File type is not allowed',
        'unable_to_retrieve_extension': 'Unable to retrieve extension',
        'no_access': 'No access',
        'field_name_exists': 'Field name already exists',
        'category_exists': 'Category with one of the names entered already exists',
        'product_brand_exists': 'Product brand with same name already exists',
        'sale_partner_exists': 'Sale partner with same name already exists',
        'additional_page_exists': 'Additional page with entered name already exists',
        'invalid_order_status': 'Invalid order status',
        'product_exists': 'Product with ID and country already exists',
        'product_slug_exists': 'Product with same name for ID and country already exists',
        'unknown_type': 'Unknown type',
        'price_list_for_selected_partner_is_empty': 'Price list for the selected partner is empty',
        'product_title_required': 'Product title is required',
        'product_country_required': 'Product country is required',
        'product_vat_group_required': 'Product VAT group is required',
        'product_price_invalid': 'Product price must not be negative',
        'product_discount_invalid': 'Product discount must be between 0 and 100',
        'product_stock_invalid': 'Product stock must not be negative',
        'vat_group_not_found_for_country': 'VAT group does not exist for the selected country',
        'category_not_found': 'Category does not exist',
        'sale_website_not_found': 'Sale website does not exist',
        'product_brand_not_found': 'Product brand does not exist',
        'specification_not_found': 'Product specification does not exist',
        'invalid_field_value': 'Invalid value in field',
        'sale_website_type_exists': 'Website with the selected type already exists',
        'discount_coupon_code_invalid': 'The code must be 3 to 50 characters of A-Z, 0-9, - and _',
        'discount_coupon_invalid_type': 'Unknown discount type',
        'discount_coupon_value_invalid': 'The discount value must be between 0 and 100',
        'discount_coupon_validity_invalid': 'Valid from must be before valid to',
        'discount_coupon_code_exists': 'A discount coupon with this code already exists',
        'discount_coupon_country_invalid': 'Unknown country on the discount coupon',
        'product_warranty_invalid': 'Warranty must not be negative and needs a unit'
    },
    'success': {
        'on_add': 'Successfully added',
        'on_edit': 'Successfully edited',
        'on_delete': 'Successfully deleted',
        'on_sort': 'Successfully sorted'
    },
    'confirmations': {
        'general': 'Are you sure you want to proceed?',
        'header': 'Are you sure',
        'delete_row': 'Are you sure you want to delete',
        'delete_all': 'Are you sure you want to delete all?',
        'unsaved_changes': 'Unsaved changes',
        'unsaved_changes_info': 'Are you sure you want to leave this page? All your modifications will be lost.',
        'disable_product': 'Are you sure you want to disable the product {title}? It will be removed from the websites, price lists and search.',
        'enable_product': 'Are you sure you want to enable the product {title} again? It will get the Unpublished status.'
    },
    'table': {
        'no_data': 'No data to display',
        'press_enter_search': 'Press enter to search',
        'search': 'Search by',
        'select_option': 'Select option',
        'select_date': 'Select date',
        'select_range': 'Select range',
        'of': 'of'
    },
    'profile': {
        'profile': 'Profile',
        'edit_profile': 'Edit profile',
        'old_password': 'Old password',
        'new_password': 'New password',
        'confirm_password': 'Confirm password',
        'change_password': 'Change password'
    },
    'language': {
        'slovenian': 'Slovenian',
        'english': 'English',
        'croatian': 'Croatian'
    },
    'country_sale': {
        'slovenia': 'Slovenia',
        'croatia': 'Croatia',
        'serbia': 'Serbia',
        'austria': 'Austria'
    },
    'user': {
        'user': 'User | Users',
        'add': 'Add user',
        'edit': 'Edit user',
        'firstname': 'Firstname',
        'lastname': 'Lastname',
        'email': 'Email',
        'language': 'Language',
        'password': 'Password',
        'cannot_edit_email': 'Email cannot be edited'
    },
    'vat_group': {
        'vat_group': 'VAT group | VAT groups',
        'add': 'Add VAT group',
        'edit': 'Edit VAT group',
        'country': 'Country',
        'prices_not_recalculated': 'Changing the VAT group does not change the prices of products that use it. Adjust the prices manually if needed.'
    },
    'discount_coupon': {
        'discount_coupon': 'Discount coupon | Discount coupons',
        'add': 'Add discount coupon',
        'edit': 'Edit discount coupon',
        'code': 'Code',
        'type': 'Discount type',
        'type_percentage': 'Percentage',
        'valid_from': 'Valid from',
        'valid_to': 'Valid to',
        'validity': 'Validity',
        'validity_hint': 'An empty date means no limit.',
        'scope': 'Where it applies',
        'scope_hint': 'An empty list means no restriction. Every filled list is a condition: the product must match the selected category, brand and product at the same time. Within one list, any entry is enough.',
        'selected_products': 'Selected products',
        'select_products': 'Select products',
        'no_selected_products': 'No products selected',
        'generate_code': 'Generate code',
        'applied_to_item': 'A discount coupon was applied to this item',
        'countries': 'Countries',
        'countries_hint': 'Only the countries of the selected websites are offered.'
    },
    'product_specification': {
        'product_specification': 'Product specification | Product specifications',
        'add': 'Add product specification',
        'edit': 'Edit product specification',
        'field_name': 'Field name',
        'field_name_info': 'It is recommended that the field name be written in English. Examples: load_capacity, height, weight.',
        'field_name_exists': 'Field name already exists',
        'required_specification': 'Required specification',
        'predefined_values': 'Predefined values',
        'value': 'Value',
        'add_new_value': 'Add new value',
        'position': 'Position'
    },
    'required_category_specification': {
        'required_category_specification': 'Required category specification | Required category specifications',
        'add': 'Add required category specifications',
        'edit': 'Edit required category specifications'
    },
    'sale_website': {
        'sale_website': 'Website | Websites',
        'add': 'Add website',
        'edit': 'Edit website',
        'type': 'Website type',
        'countries': 'Countries',
        'color': 'Color',
        'button_text': 'Button text',
        'button_type': 'Button type',
        'link': 'Link',
        'button': 'Button | Buttons',
        'no_buttons_defined': 'No buttons defined',
        'image_position': 'Image position',
        'image_on_right': 'Image on right',
        'full_width_image': 'Full width image',
        'show_background': 'Show background',
        'show_as_slider': 'Show as slider',
        'is_video': 'Is video',
        'general_info': 'General info',
        'home_page': 'Home page',
        'save_home_page': 'Save home page',
        'additional_product_pages': 'Additional product pages',
        'primary_specification_filters': 'Primary specification filters',
        'service': 'Service',
        'about_us': 'About us',
        'terms_and_conditions': 'Terms and conditions',
        'privacy_policy': 'Privacy policy',
        'company_presentation': 'Company presentation',
        'custom_solutions': 'Custom solutions',
        'representation': 'Representation',
        'customer_support': 'Customer support',
        'delivery': 'Delivery',
        'payment_methods': 'Payment methods',
        'top_nav_banner': 'Top nav banner',
        'social_media': 'Social media',
        'service_information': 'Service information',
        'contact': 'Contact',
        'active': 'Active',
        'show_in_top_navigation': 'Show in top navigation',
        'show_in_bottom_navigation': 'Show in bottom navigation',
        'page': 'Page',
        'internal_page': 'Internal page',
        'external': 'External',
        'download_attachment': 'Download attachment',
        'add_to_cart': 'Add to cart',
        'component': 'Component | Components',
        'configuration': 'Configuration',
        'select_custom': 'Select custom',
        'content': 'Content',
        'invalid_page_content_button_values': 'The selected values on pages containing buttons are incorrect. Please check all components with buttons.',
        'invalid_buttons': 'Buttons that lead nowhere',
        'invalid_buttons_info': 'These buttons point to a product or a page that does not exist anymore. Open the place the button is stored in and correct or remove it.',
        'invalid_button_place': 'Place',
        'invalid_button_reason_header': 'Reason',
        'invalid_button_component_position': 'component {index}',
        'invalid_button_item_position': 'item {index}',
        'invalid_button_button_position': 'button {index}',
        'invalid_button_location': {
            'top_nav_banner': 'Top navigation banner',
            'home_page': 'Home page',
            'additional_page': 'Additional page'
        },
        'invalid_button_reason': {
            'product_not_found': 'The product of this link does not exist',
            'additional_page_not_found': 'The additional page of this link does not exist',
            'component_data_unreadable': 'The data of the component cannot be read'
        },
        'no_components': 'This page holds no components yet',
        'no_components_info': 'Add a component by clicking one of the types in the list.',
        'email_to_which_notifications_will_be_sent': 'Email to which notifications will be sent',
        'checkout_methods': 'Payment and shipping methods',
        'checkout_methods_info': 'Only active methods with a name are offered to the customer, in the order set here. A method without a name is not saved.',
        'shipping_methods': 'Shipping methods',
        'shipping_price': 'Price',
        'shipping_price_info': 'The price is charged when the cart is heavier than every weight limit below.',
        'max_weight': 'Up to weight',
        'add_weight_price': 'Add price by weight',
        'payment_method_type': {
            'credit_card': 'Card payment',
            'bank_transfer': 'Bank transfer',
            'cash_on_delivery': 'Cash on delivery'
        },
        'shipping_method_type': {
            'local_pickup': 'Local pickup',
            'slovenian_post': 'Slovenian post',
            'intereuropa': 'Intereuropa'
        },
        'component_type': {
            'image_slider': 'Image slider',
            'item_slider': 'Item slider',
            'gallery': 'Gallery',
            'hero': 'Hero',
            'specification': 'Specification',
            'banner': 'Banner',
            'text_content': 'Text',
            'partner_slider': 'Partner slider',
            'card_slider': 'Card slider',
            'showcase_items': 'Showcase items',
            'newsletter_subscription': 'Newsletter subscription',
            'contact_form': 'Contact form',
            'button': 'Button'
        }
    },
    'product_brand': {
        'product_brand': 'Brand | Brands',
        'add': 'Add brand',
        'edit': 'Edit brand',
        'importer': 'Importer | Importers',
        'add_importer': 'Add importer',
        'edit_importer': 'Edit importer',
        'service': 'Service | Services',
        'add_service': 'Add service',
        'edit_service': 'Edit service',
        'disclaimer': 'Disclaimer | Disclaimers',
        'add_disclaimer': 'Add disclaimer',
        'warranty_hint': 'Applies to every product of this brand that has no warranty of its own.',
        'edit_disclaimer': 'Edit disclaimer',
        'website': 'Website'
    },
    'category': {
        'category': 'Category | Categories',
        'add_new': 'Add new',
        'delete_info': 'This will also delete all subcategories!',
        'not_all_fields_filled_info': 'Not all fields are filled in',
        'search': 'Search by categories',
        'ignored_categories_on_user_page': 'Ignored categories on user page',
        'choose_your_source_category': 'Choose your source category'
    },
    'product': {
        'product': 'Product | Products',
        'synced_product': 'Synced product | Synced products',
        'add': 'Add product',
        'edit': 'Edit product',
        'id': 'Product ID',
        'sku': 'SKU',
        'ean': 'EAN',
        'stock': 'Stock',
        'title': 'Title',
        'pretext': 'Pretext',
        'description': 'Description',
        'short_description': 'Short description',
        'price': 'Price',
        'regular_price': 'Regular price',
        'price_without_vat': 'Price without VAT',
        'price_with_vat': 'Price with VAT',
        'discount': 'Discount',
        'main_image': 'Main image',
        'additional_images': 'Additional images',
        'status': 'Status',
        'draft': 'Draft',
        'publish': 'Publish',
        'unpublish': 'Unpublish',
        'preview': 'Preview',
        'published': 'Published',
        'unpublished': 'Unpublished',
        'imported': 'Imported',
        'disabled': 'Disabled',
        'disable': 'Disable',
        'enable': 'Enable',
        'show_disabled': 'Show disabled',
        'videos': 'Videos',
        'cta': 'CTA (A call to action)',
        'primary_features': 'Primary features',
        'main_features': 'Main features',
        'video_features': 'Video features',
        'secondary_features': 'Secondary features',
        'product_features': 'Product features',
        'hero_banner': 'Hero banner',
        'tertiary_features': 'Tertiary features',
        'specifications': 'Specifications',
        'additional_specifications': 'Additional specifications',
        'attachment': 'Attachment',
        'attachments': 'Attachments',
        'disclaimer': 'Disclaimer',
        'section_title': 'Section title',
        'url': 'URL',
        'shipping': {
            'shipping': 'Shipping',
            'weight': 'Weight',
            'gross_weight': 'Gross weight',
            'length': 'Length',
            'width': 'Width',
            'height': 'height'
        },
        'specification': {
            'type': 'Specification type',
            'add_new_specification_type': 'Add new specification type',
            'missing_specifications': 'Missing specifications',
            'from_categories': 'From selected categories',
            'from_categories_hint': 'These specifications are added automatically based on the selected product categories.',
            'from_selected_template': 'From selected template',
            'from_selected_template_hint': 'These specifications come from the template selected in the dropdown above.',
            'template_already_from_category': 'Template "{names}" is already added automatically based on the selected categories, so its specifications will be shown twice. Clear it in the dropdown unless you need it separately.',
            'section_source': 'Template: {name}'
        },
        'section': {
            'basic_information': 'Basic information',
            'billing_information': 'Billing information',
            'media': 'Media',
            'features': 'Features',
            'specifications': 'Specifications',
            'attachments': 'Attachments',
            'disclaimer': 'Disclaimer'
        },
        'add_new_value': 'Add new value',
        'fill_from_another_locale': 'Fill from another locale',
        'fill_from_another_locale_info': 'Your current content will be erased and filled by the content of the selected locale.',
        'fill_content': 'Fill content',
        'in_use': {
            'category': 'Products on which category is used',
            'product_brand': 'Products on which brand is used',
            'product_specification': 'Products on which product specification is used',
            'sale_website': 'Products on which website is used',
            'vat_group': 'Products on which vat group is used'
        },
        'use_open_ai': 'Use OpenAI for translation',
        'export': 'Export',
        'stocks': 'Stocks',
        'prices': 'Prices',
        'product_not_synced': 'Product is not synced with ISelect',
        'warranty': 'Warranty',
        'warranty_unit': 'Warranty unit',
        'warranty_from_brand': 'brand',
        'warranty_brand_hint': 'If left empty, the brand warranty applies: {warranty}',
        'warranty_units': {
            'month': 'Months',
            'year': 'Years'
        },
        'warranty_unit_forms': {
            'month': {
                'one': 'month',
                'other': 'months'
            },
            'year': {
                'one': 'year',
                'other': 'years'
            }
        },
        'export_excel': 'Export to Excel',
        'import_excel': 'Import from Excel',
        'import_excel_result': 'Excel import result',
        'import_excel_created': 'Created products',
        'import_excel_updated': 'Updated products',
        'import_excel_specifications_updated': 'Updated specifications',
        'import_excel_errors': 'Errors',
        'import_excel_row': 'Row',
        'import_excel_success': 'Excel import succeeded',
        'import_excel_partial_success': 'Excel import partially succeeded, check the errors'
    },
    'configuration': {
        'country_configuration': 'Country configuration | Country configurations',
        'currency': 'Currency',
        'petrol_categories_mapping': 'Petrol category mapping',
        'petrol_category': 'Petrol category',
        'petrol_category_code': 'Code',
        'add_petrol_category': 'Add Petrol category',
        'edit_petrol_category': 'Edit Petrol category',
        'petrol_category_exists': 'A Petrol category with code {code} already exists',
        'petrol_category_missing_name': 'Name missing',
        'petrol_category_missing_name_error': 'Petrol categories without a code or name: {codes}. Fill them in and save again.',
        'delete_petrol_category_in_use': 'Categories mapped to Petrol category {code} {name}: {count}. Once saved, their products will be exported to Petrol without a classification. Do you really want to delete it?'
    },
    'additional_page': {
        'additional_page': 'Additional page | Additional pages',
        'add': 'Add additional page',
        'edit': 'Edit additional page',
        'save': 'Save additional page',
        'for': 'Additional page for {name}',
        'add_in_other_language': 'Add in another language',
        'add_in_other_language_info': 'A new page with the copied content of this page will be added in the selected language.',
        'exists_in_all_languages': 'The page exists in every language of this sale website',
        'new_page': 'New page',
        'copied_from_page': 'The data is copied from the page "{name}". Pick a country and saving will create a new page.'
    },
    'sale_partner': {
        'sale_partner': 'Sale partner | Sale partners',
        'add': 'Add sale partner',
        'edit': 'Edit sale partner',
        'partner_key': 'Partner key',
        'product_export_type': 'Product export type',
        'empty_price_list': 'The price list is empty for the selected partner.',
        'prices': 'Price list',
        'product_key': 'Product code',
        'price_list_name': 'Price list name',
        'price_list_code': 'Price list code',
        'validity': 'Validity',
        'last_updated': 'Last updated'
    },
    'order': {
        'order': 'Order | Orders',
        'show_order': 'Show order',
        'order_number': 'Order number',
        'copy_order_number': 'Copy order number',
        'order_date': 'Order date',
        'total': 'Total',
        'order_status': 'Order status',
        'payment_status': 'Payment status',
        'order_success': 'Order successful',
        'order_failed': 'Order failed',
        'customer': 'Customer',
        'created': 'Created',
        'quantity': 'Quantity',
        'subtotal': 'Subtotal',
        'phone': 'Phone',
        'billing_address': 'Billing address',
        'shipping_address': 'Shipping address',
        'same_as_billing_address': 'Same as billing address',
        'payment': 'Payment',
        'order_history': 'Order history',
        'items_in_order': 'Items in order',
        'transaction_id': 'Transaction ID',
        'message': 'Message',
        'status': {
            'pending': 'Ordered',
            'processing': 'Processing',
            'shipped': 'Shipped',
            'ready_for_pickup': 'Ready for pickup',
            'completed': 'Completed',
            'not_picked_up': 'Completed / not picked up',
            'cancelled': 'Cancelled'
        },
        'status_payment': {
            'pending': 'Pending',
            'paid': 'Paid',
            'failed': 'Failed',
            'refunded': 'Refunded'
        }
    },
    'inquiry': {
        'inquiry': 'Inquiry | Inquiries',
        'show_inquiry': 'Show inquiry',
        'empty': 'You currently have no active inquiries.',
        'terms_1': 'By submitting an inquiry, I agree to',
        'add_to_inquiry': 'Add to inquiry',
        'proceed_to_offer': 'Proceed to offer',
        'preparation_of_offer': 'Preparation of offer',
        'success_add_to_inquiry': 'Product successfully added to inquiry!',
        'go_to_inquiry_overview': 'Proceed to inquiry overview',
        'send_inquiry': 'Send inquiry',
        'address': 'Address',
        'inquiry_success': 'Inquiry sent successfully',
        'inquiry_failed': 'Inquiry failed',
        'inquiry_number': 'Number inquiry',
        'date_of_sent_inquiry': 'Date of sent inquiry',
        'inquiry_status': 'Inquiry status',
        'inquiry_history': 'Inquiry history',
        'items_in_inquiry': 'Items in inquiry',
        'status': {
            'pending': 'Sent',
            'processing': 'Processing',
            'completed': 'Completed',
            'cancelled': 'Cancelled'
        }
    },
    'theme': {
        'light': 'Light theme',
        'dark': 'Dark theme',
        'auto': 'Automatic (follow system)'
    },
    'template': {
        'specification_template': 'Specification template | Specification templates',
        'categories_changed_warning': 'You changed the categories of this template. The change affects existing products.',
        'categories_removed': 'Removed categories: {names}',
        'categories_removed_effect': 'Products in these categories will lose the specification sections from this template, including the values already entered. Affected products: {count}',
        'categories_added': 'Added categories: {names}',
        'categories_added_effect': 'Products in these categories will automatically get the specification sections from this template, with empty values. Affected products: {count}',
        'categories_changed_hint': 'For an individual product the change takes effect the next time you open it for editing and save it.'
    },
    'sync_status': {
        'sync_status': 'Sync status | Sync statuses',
        'running': 'Running',
        'started_at': 'Started at',
        'last_finished_at': 'Last finished at',
        'refresh': 'Refresh',
        'force_sync_ishop_data': 'Sync iShop data',
        'force_sync_sale_partner_price_lists': 'Sync partner price lists',
        'sync_started': 'Sync started and is running in the background',
        'sync_already_running': 'Sync is already running',
        'names': {
            'sync_ishop_product_data': 'Product data sync',
            'sync_ishop_product_stock': 'Stock sync',
            'sync_data_with_fts': 'Full text search sync',
            'sync_ishop_sale_partner_price_list': 'Partner price list sync'
        }
    }
}
